// extracted by mini-css-extract-plugin
export default {"container":"TL-z","topReviewHeading":"UL-z","criticalReview":"VL-z","favorableReview":"WL-z","vsSeparator":"XL-z"};